import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import withMobileDialog from "@material-ui/core/withMobileDialog";

class PDPADialog extends React.Component {
  state = {
    open: false,
    scroll: "paper"
  };

  handleClickOpen = scroll => () => {
    this.setState({ open: true, scroll });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    return (
      <span>
        <a onClick={this.handleClickOpen("paper")}>PDPA Agreement</a>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          scroll={this.state.scroll}
          aria-labelledby="scroll-dialog-title"
        >
          <DialogTitle id="scroll-dialog-title">PDPA Agreement</DialogTitle>
          <DialogContent>
            KBE Air Conditioning And Engineering Pte Ltd recognises its
            obligations under the Personal Data Protection Act 2012 (PDPA) which
            include the collection, use and disclosure of personal data for the
            purpose for which an individual has given consent to.The personal
            data collected by KBE Air Conditioning And Engineering Pte Ltd includes all personal
            data provided in this form, or in any supplementary form or any
            document provided, or to be provided to us by you or from other
            sources from time to time, for the purpose of the services or
            products transaction. It includes all personal data for us to
            evaluate or administer the transaction.
            <ol>
              <li>
                Purpose of collection <br />
                We may collect and use the personal data to:
                <ul>
                  <li>carry out identity checks;</li>
                  <li>communicate on purposes relating to the transaction;</li>
                  <li>
                    provide ongoing services and respond to your inquiries or
                    instructions;
                  </li>
                  <li>make or obtain payments;</li>
                  <li>recover any debt owed to us;</li>
                  <li>
                    detect and prevent fraud, unlawful or improper activities;
                  </li>
                  <li>conduct research and statistical analysis;</li>
                  <li>coach employees and monitor for quality assurance;</li>
                  <li>
                    comply with all applicable laws, including reporting to
                    regulatory and industry entities; and
                  </li>
                </ul>
                If you have given your consent under marketing material option,
                we may also collect and use your personal data to contact you on
                our marketing or promotional materials relating to our financial
                products or services via telephone calls, text messages, faxes,
                mails, or emails.
              </li>
              <li>
                Disclosure of personal data <br />
                We may disclose personal data belonging to you for the purposes
                set out in Section 1 above to these parties:
                <ul>
                  <li>
                    local or overseas service providers to provide us with
                    services such as courier service, underwriting survey,
                    printing, mail distribution, data storage, data entry,
                    marketing and research;
                  </li>
                  <li>debt collection agencies;</li>
                  <li>dispute resolution parties;</li>
                  <li>regulators, law enforcement and government agencies.</li>
                </ul>
              </li>
              <li>
                Consequence of withdrawing consent to the collection, use and
                disclosure of personal data <br />
                You may refuse or withdraw your consent for us to collect, use
                or disclose your personal data by giving us reasonable notice so
                long as there are no legal or contractual restrictions
                preventing you from doing so. For example, you may withdraw your
                consent for your personal data to be used for marketing
                purposes, and this withdrawal will not affect our ability to
                provide you with the products and services that you asked for or
                have with us. But if you withdraw your consent for us to use
                your personal data for transaction such as appointment
                scheduling, this will affect our ability to provide you with the
                products and services that you asked for or have with us.
                Withdrawing such consent will require you to surrender or
                terminate all your existing packages or fully settle any other
                outstanding transactions you have with us.
              </li>
              <li>
                Access and correction rights <br />
                You can request access to any personal data of yours that we
                have, and request to know how it is being used and disclosed for
                the last 12 months to the extent your right is allowed by law.
                If we allow you access, we may charge you a reasonable fee. You
                also have the right to request correction of your personal data.
              </li>
            </ol>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </span>
    );
  }
}

export default withMobileDialog()(PDPADialog);



// WEBPACK FOOTER //
// ./src/pages/main/components/PDPADialog.js